<head>
  <meta charset="UTF-8" />
  <meta name="viewport" content="width=device-width, initial-scale=1.0" />
  <title>AIC ONE - Login</title>
</head>

<body class="login-home background-body">
  <div class="container align-items-center d-flex">

    <!-- Logo Section -->
    <div class="logo-section">
      <img :src="styleConfig.login_page_logo" alt="aicone Logo" class="logo"/>
      <div class="user-count d-none">
        <div class="user-dots d-flex">
          <div class="dot"></div>
          <div class="dot"></div>
          <div class="dot"></div>
        </div>
        <span>3k+ people joined us, now it's your turn</span>
      </div>
    </div>

    <!-- Login Form -->
    <div class="sign-in-form">
      <div class="mb-4 text-start">
        <h2 class="text-black fw-bold">Log in</h2>
        <p class="text-black mt-3 fw-bold" :class="{ 'd-none': !(is_cloud_domain && is_internal) }">
          New user? <a href="/register" class="text-black">Create an account</a>
        </p>
      </div>

      <form @submit.prevent="submit_form">

        <!-- Microsoft SSO -->
        <div class="row g-2 mb-3">
          <div class="col-12 col-md-6">
            <button
              type="button"
              class="btn btn-outline-dark w-100 fw-bold"
              :disabled="microsoft_loading"
              @click="sign_in_with_microsoft"
            >
              <span v-if="!microsoft_loading">
                <svg width="18" height="18" viewBox="0 0 21 21" xmlns="http://www.w3.org/2000/svg" style="vertical-align:middle;margin-right:8px;">
                  <rect x="1" y="1" width="9" height="9" fill="#F25022"/>
                  <rect x="11" y="1" width="9" height="9" fill="#7FBA00"/>
                  <rect x="1" y="11" width="9" height="9" fill="#00A4EF"/>
                  <rect x="11" y="11" width="9" height="9" fill="#FFB900"/>
                </svg>
                Sign in
              </span>
              <div v-else class="spinner-border spinner-border-sm" role="status"></div>
            </button>
          </div>

          <div class="col-12 col-md-6">
            <button
              type="button"
              class="btn btn-outline-dark w-100 fw-bold"
              :disabled="microsoft_signup_loading"
              @click="sign_up_with_microsoft"
            >
              <span v-if="!microsoft_signup_loading">
                <svg width="18" height="18" viewBox="0 0 21 21" xmlns="http://www.w3.org/2000/svg" style="vertical-align:middle;margin-right:8px;">
                  <rect x="1" y="1" width="9" height="9" fill="#F25022"/>
                  <rect x="11" y="1" width="9" height="9" fill="#7FBA00"/>
                  <rect x="1" y="11" width="9" height="9" fill="#00A4EF"/>
                  <rect x="11" y="11" width="9" height="9" fill="#FFB900"/>
                </svg>
                Sign up
              </span>
              <div v-else class="spinner-border spinner-border-sm" role="status"></div>
            </button>
          </div>
        </div>

        <div v-if="microsoft_error" class="alert alert-danger mt-3 text-start">
          {{ microsoft_error }}
        </div>

        <!-- Divider -->
        <div class="text-center my-3">
          <span class="text-muted small">or sign in with email</span>
        </div>

        <!-- Email -->
        <div class="form-floating-custom">
          <input type="text" class="form-input" placeholder=" " v-model="form.email">
          <label for="" class="form-label">Email Address</label>
          <div v-if="errors.email" class="error-message text-start text-danger small">{{ errors.email }}</div>
        </div>

        <!-- Password -->
        <div class="form-floating-custom password-group">
          <input :type="password_visible ? 'text' : 'password'" id="password" class="form-input" placeholder="" v-model="form.password">
          <label for="password" class="form-label">Password</label>
          <button type="button" class="password-toggle" @click="password_visibility()">
            <i :class="password_visible ? 'fa fa-eye-slash' : 'fa fa-eye'"></i>
          </button>
          <div v-if="errors.password" class="error-message text-start text-danger fs-6">{{ errors.password }}</div>
        </div>

        <!-- Submit -->
        <button
          type="submit"
          class="btn sign-up-btn btn-dark w-100 fw-bold mb-2"
          :disabled="loading"
        >
          <span v-if="!loading">Log In</span>
          <div v-else class="spinner-border spinner-border-sm text-light" role="status"></div>
        </button>

        <!-- Forgot Password -->
        <div class="forgot-password mt-3 text-center small">
          <span>Forgot your password? <a href="/reset">Click here</a> to reset</span>
        </div>

      </form>
    </div>

  </div>
</body>
